import React, { useState, useEffect } from "react";

import SearchButton from "../../../components/buttons/search/search-btn";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import CustomTable from "../../../components/table/table";
import "./view.css";
import CSVExport from "../../../components/csvExport";
import { get_resList_list, admin_resper_delete } from "../admin.api";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import jwtDecode from "jwt-decode";
import moment from "moment";
import * as XLSX from "xlsx";
import ManageDomain from "./manage/manage";

export default function View(props) {
  const [data, setdata] = useState([]);
  const [view, setView] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [formData, setFormData] = useState({});

  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const onSearch = () => {
    //
  };
  const handleAdviserList = () => {
    setIsActive(true);
    get_resList_list(adminType).then((res) => {
      let tdata = res.data;
      let searchData = [];
      tdata.forEach((item, index) => {
        item["slno"] = index + 1;
        // searchData.push(item?.expert_manpower);
      });
      setdata(tdata);
      setIsActive(false);
    });
  };
  const handleAddNew = (row) => {
    let path = `/resource-add`;
    props.history.push(path);
  };

  const handleView = (data) => {
    let path = `/resource-view/${data.user_id}`;
    props.history.push(path);
  };

  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    admin_resper_delete(data.id)
      .then((res) => {
        // setSnackMessage(res.message);
        setSnackMessage("Resource Personnel deleted successfully");
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleAdviserList();
    }
  };
  const handleDownload = () => {};
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  useEffect(() => {
    handleAdviserList();
  }, []);
  async function fetchExportData() {
    const exportdata = [];
    data.forEach((item) => {
      exportdata.push({
        Name: `${item?.title}. ${item?.first_name} ${
          item?.middle_name ? item?.middle_name : ""
        } ${item?.last_name}`,
        Email: item.email,
        ["Phone Number"]: item.phone_no,
        Date: item.created_at
          ? moment(item.created_at).format("DD-MMM-YYYY hh:mm A")
          : "--",
        Status:
          item.approval_status === 0
            ? "Pending"
            : item.approval_status === 1
            ? "Submitted"
            : item.approval_status === 2
            ? "Approved"
            : item.approval_status === 3
            ? "SA Reverted"
            : item.approval_status === 4
            ? "Rejected"
            : item.approval_status === 5
            ? "Reverted"
            : "",
      });
    });
    return exportdata;
  }
  const downloadExcel = async () => {
    const exportData = await fetchExportData();
    if (!exportData.length) {
      setSnackMessage("No data to export");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Resource Personnel");

    XLSX.writeFile(workbook, "Resource_Personnel.xlsx");
  };

  const handleEdit = (data) => {
    setFormData(data);
    setView(false);
    setEdit(true);
  };
  const handleClose = () => {
    setEdit(false);
    setFormData({});
    handleAdviserList();
  };
  return (
    <div>
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="view-container">
        {/* <h6>
          <b>Resource Personnel</b>
        </h6> */}
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="m-0">
            <b>Resource Personnel</b>
          </h6>
          <button
            className="px-2 py-2 search-style border-0 text-white rounded"
            onClick={downloadExcel}
          >
            Download Excel
          </button>
        </div>
        <hr />
        {/* ---------admin--------------- */}
        {adminType === 1 && (
          <>
            {/* <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={(e) => handleAddNew(e)}
            >
              Add New
            </button> */}
            {/* <div className="row font-z mt-2">
              <div className="col-3 ">
                <select className="form-select" aria-label="Default select example">
                  <option selected>Select Application Status</option>
                  <option value="1">Pending</option>
                  <option value="2">Accepted</option>
                </select>
              </div>
              <div className="col-1 d-flex">
                <SearchButton {...props} onClick={onSearch} />
              </div>
            </div> */}
            <CustomTable
              {...props}
              columns={[
                {
                  title: "Name",
                  field: "first_name",
                  render: (row) => (
                    <>
                      {row.first_name && row.first_name}{" "}
                      {row.middle_name && row.middle_name}{" "}
                      {row.last_name && row.last_name}
                    </>
                  ),
                },
                { title: "Email", field: "email" },
                {
                  title: "Photo",
                  field: "file_upload",
                  type: "resource-image",
                },
                { title: "Phone Number", field: "phone_no" },
                // { title: "Area of Expertise", field: "category" },

                {
                  title: "Status",
                  field: "approval_status",
                  type: "regstatusType",
                },
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                { type: "edit", handleClick: handleEdit },
                // { type: "delete", handleClick: handleDelete },
              ]}
            />
          </>
        )}
        {/* -------------super admin------ */}
        {adminType === 2 && (
          <>
            {/* <div className="row font-z"> */}
            {/* <div className="col-3 ">
                <select className="form-select" aria-label="Default select example">
                  <option selected>Select Application Status</option>
                  <option value="1">Pending</option>
                  <option value="2">Accepted</option>
                </select>
              </div>
              <div className="col-1 d-flex">
                <SearchButton {...props} onClick={onSearch} />
              </div>
            </div> */}
            <CustomTable
              {...props}
              columns={[
                {
                  title: " Name",
                  field: "first_name",
                  render: (row) => (
                    <>
                      {row.first_name && row.first_name}{" "}
                      {row.middle_name && row.middle_name}{" "}
                      {row.last_name && row.last_name}
                    </>
                  ),
                },
                { title: "Email", field: "email" },
                {
                  title: "Photo",
                  field: "file_upload",
                  type: "resource-image",
                },
                { title: "Phone Number", field: "phone_no" },
                // { title: "Area of Expertise", field: "category" },

                {
                  title: "Status",
                  field: "approval_status",
                  type: "regstatusType",
                },
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                { type: "delete", handleClick: handleDelete },
              ]}
            />
          </>
        )}
        {adminType === 23 && (
          <>
            {/* <div className="row font-z"> */}
            {/* <div className="col-3 ">
                <select className="form-select" aria-label="Default select example">
                  <option selected>Select Application Status</option>
                  <option value="1">Pending</option>
                  <option value="2">Accepted</option>
                </select>
              </div>
              <div className="col-1 d-flex">
                <SearchButton {...props} onClick={onSearch} />
              </div>
            </div> */}
            <CustomTable
              {...props}
              columns={[
                {
                  title: " Name",
                  field: "first_name",
                  render: (row) => (
                    <>
                      {row.first_name && row.first_name}{" "}
                      {row.middle_name && row.middle_name}{" "}
                      {row.last_name && row.last_name}
                    </>
                  ),
                },
                { title: "Email", field: "email" },
                {
                  title: "Photo",
                  field: "file_upload",
                  type: "resource-image",
                },
                { title: "Phone Number", field: "phone_no" },
                // { title: "Area of Expertise", field: "category" },

                {
                  title: "Status",
                  field: "approval_status",
                  type: "regstatusType",
                },
              ]}
              data={data}
              actions={[{ type: "view", handleClick: handleView }]}
            />
          </>
        )}
        {/* -------------super admin------ */}
      </div>
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Resource Personnel ?"
          data={activeData}
          message="Are you sure to delete this Resource Personnel?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
      {edit && (
        <ManageDomain
          open={edit}
          edit={edit}
          view={view}
          handleClose={handleClose}
          formData={formData}
        />
      )}
    </div>
  );
}
